import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { BookMarked, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DigitalContent } from "@/types/digitalContent";
import { PublicDigitalContentCard } from "@/components/digitalContent/PublicDigitalContentCard";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5 },
  },
};

interface GuidesSectionProps {
  guides: DigitalContent[] | undefined;
}

export const GuidesSection: React.FC<GuidesSectionProps> = ({ guides }) => {
  const navigate = useNavigate();

  // Não renderizar a seção se não houver guias
  if (guides && guides.length === 0) return null;

  return (
    <section className="py-16 md:py-24 px-4 relative">
      <div className="absolute top-1/4 right-1/3 w-64 h-64 bg-[#8B5CF6] opacity-10 blur-[100px] rounded-full -z-10"></div>
      <div className="absolute bottom-1/4 left-1/3 w-80 h-80 bg-[#00B6F0] opacity-10 blur-[120px] rounded-full -z-10"></div>

      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-12">
          <BookMarked className="h-6 w-6 text-[#00B6F0]" />
          <h2 className="text-3xl md:text-4xl font-bold text-white">Guias Disponíveis</h2>
        </div>

        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          {guides ? (
            guides.slice(0, 3).map((guide) => (
              <motion.div key={guide.id} variants={itemVariants}>
                <PublicDigitalContentCard content={guide} />
              </motion.div>
            ))
          ) : (
            Array.from({ length: 3 }).map((_, index) => (
              <div key={index} className="w-full h-80 bg-[#181D24] rounded-xl animate-pulse"></div>
            ))
          )}
        </motion.div>

        <div className="mt-12 text-center">
          <Button
            onClick={() => navigate("/guias")}
            variant="outline"
            size="lg"
            className="border-[#00B6F0] text-[#00B6F0] hover:bg-[#00B6F0]/10"
          >
            Ver Todos os Guias
            <ChevronRight className="ml-2 h-4 w-4" />
          </Button>
        </div>
      </div>
    </section>
  );
};
